export const getResetPasswordUrl = (location: Pick<Location, 'origin' | 'pathname'>) => {
  const project = location.pathname.split('/').at(-2);

  return project ? `${location.origin}/${project}/reset-password` : `${location.origin}/reset-password`;
};
